<template>
    <header class="main-header navbar">
            <div class="col-search">
            </div>
            <div class="col-nav">
                <button class="btn btn-icon btn-mobile me-auto" data-trigger="#offcanvas_aside"> <i class="material-icons md-apps"></i> </button>
                <ul class="nav">
                    <!-- <li class="nav-item">
                        <a class="nav-link btn-icon" href="#">
                            <i class="material-icons md-notifications animation-shake"></i>
                            <span class="badge rounded-pill">3</span>
                        </a> @click="readNotification"
                    </li> -->
                    <a-dropdown class="notification-item" :trigger="['click']">
                        <a class="ant-dropdown-link nav-link btn-icon" @click.prevent>
                            <i class="material-icons md-notifications"  @click="readNotification"></i>
                            <span class="badge rounded-pill">
                                {{unreadNotification && unreadNotification.length ? unreadNotification.length : '0'}}
                            </span>
                        </a>
                        <template #overlay>
                        <a-menu class="p-1 notification-dropdown-item" :class="{ 'notification-exis': notifications && notifications.length }">
                            
                            <template v-if="notifications && notifications.length">
                                <template v-for="noti in notifications">
                                    <a-menu-item v-if="noti && noti.data" :key="noti.id" class="mb-3 pb-2 noti-dropdown-item" :class="{'not-read-at': !noti.read_at}">
                                        <div class="d-flex align-items-start">
                                            <div >
                                                <p class="mb-1 font-weight-medium font-15"> Order Id: #{{noti.data.unique_id}} </p>
                                                <p class="mb-2 font-13 font-weight-normal"> {{moment(noti.created_at).format("DD MMM, YYYY")}} </p>   
                                                <ul class="list-unstyled pl-0">
                                                    <li>
                                                        <div class="d-flex align-items-center">
                                                            <div class="noti-order-table"> 
                                                                <p class="mb-0 font-13 font-weight-medium"> 
                                                                    {{noti.data.body}}
                                                                </p>
                                                            </div> 
                                                        </div>  
                                                    </li>
                                                </ul>  
                                                <a :href="noti.data.actionURL" class="text-underline font-12 text-muted pl-0 font-weight-normal">See Order Details</a>   
                                            </div>  
                                        </div>
                                    </a-menu-item>
                                </template>
                            </template>

                            <a-menu-item key="1"  class="noti-dropdown-item text-center">
                                <router-link to="/notification-list">
                                    View All
                                </router-link>
                            </a-menu-item>
                        </a-menu>
                        </template>
                    </a-dropdown>
                    <li v-if="userInfo && userInfo.roles && userInfo.roles.length && userInfo.roles[0].name" class="nav-item mx-3">
                        <!-- <a href="#" class="requestfullscreen nav-link btn-icon"><i class="material-icons md-cast"></i></a> -->
                        {{ userInfo.roles[0].name }}
                    </li>
                    <!-- <li class="nav-item">
                        <a href="#" class="requestfullscreen nav-link btn-icon"><i class="material-icons md-cast"></i></a>
                    </li> -->


                    <!-- <a-select
                        class="mx-2"
                        :value="$i18n.locale"
                        style="width: 60px"
                        ref="select"
                        @change="value => $i18n.locale = value"
                    >
                        <a-select-option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</a-select-option>
                    </a-select> -->

                    <a-dropdown :trigger="['click']">
                        <a class="ant-dropdown-link" @click.prevent>
                            <img v-if="userInfo && userInfo.image_path" class="img-xs rounded-circle" 
                                :src="userInfo.image_path" alt="User">
                            <img v-else class="img-xs rounded-circle" 
                                src="../../assets/imgs/people/User_icon.png" alt="User">  
                            <a-icon type="down" />
                        </a>
                        <!--  -->
                        <template #overlay>
                        <a-menu class="p-1">
                            <a-menu-item key="0">
                                <router-link to="/edit-profile" class="dropdown-item">
                                    <i class="material-icons md-perm_identity mr-2"></i>Edit Profile
                                </router-link>
                            </a-menu-item>

                            <a-menu-item key="1">
                                <a class="dropdown-item" @click="showModal"><i class="material-icons md-settings mr-2"></i>Change Password</a>
                            </a-menu-item>
                            <a-menu-divider />
                            <a-menu-item key="3">
                                <a @click="logoutUser" class="dropdown-item text-danger">
                                    <i class="material-icons md-exit_to_app mr-2"></i>
                                    Logout
                                </a>
                            </a-menu-item>
                        </a-menu>
                        </template>
                    </a-dropdown>

                </ul>
            </div>

            <a-modal
                title="Change Password"
                :visible="showChangePassword"
                @cancel="() => this.showChangePassword = false"
                :footer="null"
                >
                <a-form :form="form" layout='vertical' @submit="changePassword">
                    <a-form-item label="Current Password">
                        <a-input size="large"
                            v-decorator="[
                            'old_password',
                            { rules: [{ required: true, message: 'Please input your Password!' }] },
                            ]"
                            type="password"
                            placeholder="Current Password"
                        >
                            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-item>
                    <a-form-item label="New Password">
                        <a-input size="large"
                            v-decorator="[
                            'new_password',
                            { rules: [{ required: true, message: 'Please input your Password!' }] },
                            ]"
                            type="password"
                            placeholder="New Password"
                        >
                            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-item>

                    <a-form-item label="Confirm Password">
                        <a-input size="large"
                            v-decorator="[
                            'confirm_password',
                            { rules: [{ required: true, message: 'Please input your Password!' }] },
                            ]"
                            type="password"
                            placeholder="Confirm Password"
                        >
                            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-button @click="() => this.showChangePassword = false" size="large">
                            Cancel
                        </a-button>
                        <a-button type="primary" :loading="loading" size="large" class="float-right btn btn-xs" html-type="submit">
                            Submit
                        </a-button>
                    </a-form-item>
                </a-form>
            </a-modal>
        </header>
</template>

<script>
import {logoutUser} from "../../script/helper";
import {MY_PROFILE, CHANGE_PASSWORD, NOTIFICATION_LIST, NOTIFICATION_MAKE_READ} from "../../script/api";
import {getData, postData} from "../../script/api-service";
import * as Cookies from "js-cookie";
import moment from "moment";

export default {
    data () {
        return {
            langs: ['en', 'bn'],
            showChangePassword: false,
            form: this.$form.createForm(this, { password: '', new_password: '', confirm_password: '' }),
            userInfo: null,
            loading: false,
            notifications: null,
            unreadNotification: null,
            interval: null
        }
    },
    components: {
    },
    methods: {
        moment,
        showModal() {
            this.showChangePassword = true;
        },
        changePassword(e) {
            e.preventDefault();
            this.form.validateFields(async (err, values) => {
                if (!err) {
                    this.loading = true;
                    let res = await postData(CHANGE_PASSWORD, values);

                    if (res) {
                        this.form.resetFields();
                        this.showChangePassword = false;
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                }
            });
        },
        logoutUser() {
            logoutUser();
        },
        async getUserProfile() {
            let res = await getData(MY_PROFILE);

            if (res) {
                let masterData = res?.data?.data?.user;
                this.userInfo = masterData || null;
                localStorage.setItem('logistic-userinfo', JSON.stringify(this.userInfo));

                Cookies.set('logistic-userinfo-permission', JSON.stringify(this.userInfo.roles[0].permissions));
                sessionStorage.setItem("logistic-userinfo-permission", JSON.stringify(this.userInfo.roles[0].permissions));
            }
        },
        async getNotificationList() {
            let res = await getData(NOTIFICATION_LIST);

            if (res) {
                let masterData = res.data.data;
        // masterData?.unread_notifications?.length ? masterData.unread_notifications : 
                this.notifications = masterData?.all_notifications?.data;
                this.unreadNotification = masterData?.unread_notifications;
            }
        },
        async readNotification() {
            let res = await postData(NOTIFICATION_MAKE_READ);

            console.log("res ===========> ", res);
        } 
    },
    mounted() {
        this.getUserProfile();
        this.getNotificationList();
        this.interval = setInterval(() => {
            this.getNotificationList()
        }, 60 * 1000);
    },
    destroyed() {
        clearInterval(this.interval);
    }
};
</script>